import React from 'react';

import { Flex, Icon, Text } from '@opendoor/bricks/core';

import { useMobileDevice } from 'shared/helpers/hooks/useMobileDevice';

/**
 * Value props for the Buy Direct checkout flow
 * storybook-check-ignore
 */
export const ValueProps = React.memo(() => {
  const { isMobile } = useMobileDevice();
  return (
    <Flex
      flexDirection="column"
      alignItems={['center', 'flex-start', 'flex-start', 'flex-start']}
      mb={[6, 6, 6, 8]}
      width="100%"
    >
      <Text size={isMobile ? '160' : '150'} py={8} fontWeight="medium">
        Benefits when you buy directly from Opendoor
      </Text>
      <Flex flexDirection="row" alignItems="center" mb={5}>
        <Icon size={16} name="checkmark" aria-hidden="true" mr={6} />
        <Text size="110">Appraisal match guarantee up to $50,000. See terms</Text>
      </Flex>
      <Flex flexDirection="row" alignItems="center" alignSelf={['flex-start', null, null]} mb={5}>
        <Icon size={16} name="checkmark" aria-hidden="true" mr={6} />
        <Text size="110">Get help every step of the way, 7 days a week.</Text>
      </Flex>
      <Flex flexDirection="row" alignItems="center" mb={5}>
        <Icon size={16} name="checkmark" aria-hidden="true" mr={6} />
        <Text size="110">
          Change your mind any time before closing and get 100% of your earnest money back.
        </Text>
      </Flex>
    </Flex>
  );
});

ValueProps.displayName = 'ValueProps';
